import { Property } from "./interfaces";

export const fechaNacimiento: Property = {
  title: "Fecha de Nacimiento",
  type: "string",
  format: "date",
};
